<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-next`]" width="1em" height="1em" v-bind="$attrs"><path d="M9.5791 2.27485C9.8388 2.01515 10.2608 2.01515 10.5205 2.27485L13.4053 5.15962C13.4359 5.19026 13.4631 5.22409 13.4873 5.2602C13.4992 5.27792 13.5076 5.29733 13.5176 5.31587C13.5279 5.33507 13.5404 5.35321 13.5488 5.37349C13.5579 5.3953 13.5627 5.41838 13.5693 5.44087C13.5752 5.46064 13.5829 5.47994 13.5869 5.50044C13.6035 5.5849 13.6042 5.67179 13.5879 5.7563C13.5838 5.77751 13.5754 5.79738 13.5693 5.81782C13.5628 5.84002 13.5578 5.86268 13.5488 5.88423C13.5404 5.90453 13.5279 5.92262 13.5176 5.94184C13.5076 5.96041 13.4992 5.97976 13.4873 5.99751C13.4629 6.03408 13.4363 6.06907 13.4053 6.10005L10.5205 8.98579C10.2608 9.24513 9.83871 9.24526 9.5791 8.98579C9.31951 8.7262 9.31972 8.30411 9.5791 8.04438L11.3301 6.29438H6.87695C5.13947 6.2948 3.73076 7.70336 3.73047 9.44087C3.73047 11.1786 5.13929 12.5879 6.87695 12.5883H8C8.36723 12.5883 8.66498 12.8861 8.66504 13.2534C8.66498 13.6206 8.36723 13.9184 8 13.9184H6.87695C4.40475 13.918 2.40039 11.9132 2.40039 9.44087C2.40068 6.96882 4.40493 4.96472 6.87695 4.96431H11.3281L9.5791 3.21528C9.31971 2.95583 9.32016 2.53459 9.5791 2.27485Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineNext',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
